import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import useStylesExpansionPanel from "../../../hooks/useStylesExpansionPanel";
import AbtcAvatar from "../../../custom/Avatar";
import { ChevronRight } from "@material-ui/icons";

export const CustomerListBySituationWithAccordion = ({ filter, textBar, data }) => {
  const [open, setOpen] = useState(false);
  const classes = useStylesExpansionPanel();

  const hasFilters = useMemo(() => {
    return filter?.searchById?.length > 0 || filter?.searchByText?.length > 0 || filter?.situationsSelected?.length > 0;
  }, [filter]);

  useEffect(() => {
    if (data?.length && hasFilters) {
      setOpen(true);
    }
  }, [data, hasFilters]);

  if (!data?.length) return null;

  return (
    <Accordion
      expanded={open}
      onChange={() => setOpen((prev) => !prev)}
      classes={{
        root: classes.root,
        expanded: classes.expanded,
      }}
      TransitionProps={{
        mountOnEnter: true,
        unmountOnExit: false,
      }}
    >
      <AccordionSummary
        classes={{
          root: classes.summary,
          expanded: classes.expanded,
          content: classes.content,
        }}
        expandIcon={<ExpandMoreIcon color="primary" />}
      >
        <Typography
          color="primary"
          variant="subtitle1"
        >
          <FormattedMessage id={textBar} /> ({data.length})
        </Typography>
      </AccordionSummary>

      <AccordionDetails classes={{ root: classes.content }}>
        <List classes={{ root: classes.list }}>
          {data.map((c) => (
            <ListItem
              key={c.id}
              component={Link}
              disableGutters
              button
              classes={{ root: classes.listItem }}
              to={{
                pathname: `/customer-detail/${c.id}`,
                state: {
                  backTo: "/customer-management/customers",
                  filter: filter,
                },
              }}
            >
              <ListItemAvatar>
                <AbtcAvatar
                  imageUrl={c.photoUrl}
                  disableLink
                  enablePremiumBorder={c.premium}
                />
              </ListItemAvatar>

              <ListItemText
                primary={`${c.name} (${c.id})`}
                secondary={
                  <>
                    <Typography
                      color="textSecondary"
                      variant="subtitle2"
                      component="span"
                    >
                      <FormattedMessage id={`app.${c.role.toLowerCase()}`} /> {` - ${c.email}`}
                    </Typography>
                    {c.premium && (
                      <Typography
                        color="primary"
                        component={"span"}
                        variant="caption"
                      >
                        {" Premium"}
                      </Typography>
                    )}
                  </>
                }
              />

              <ChevronRight />
            </ListItem>
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};
